import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import ReactPlayer from 'react-player'


export default function VideoPlayerDialog({ exerciseId, handleSetTitle }) {
    const programCategories = useSelector((state) => state.programCategories.categories)
    const userPrograms = useSelector((state) => state.userProgram.userProgram)

    const allVideos = useSelector((state) => state.allVideos.videos)
    const adminPrograms = programCategories && programCategories.flatMap((category) => category.adminPrograms)
    const allExercises = adminPrograms && adminPrograms.flatMap((p) => p.exercises)

    const [link, setLink] = useState('')
    const [description, setDescription] = useState('')


    useEffect(() => {
        let foundItem = userPrograms && userPrograms.find((p) => p.id === exerciseId);
        if (!foundItem) {
            foundItem = allExercises.find((p) => p.id === exerciseId);
            if (!foundItem) {
                foundItem = allVideos.find((p) => p.id === exerciseId);
            }
        }
        if (foundItem) {
            setLink(foundItem.link);
            setDescription(foundItem.description)
            handleSetTitle(foundItem.name)
        }
    }, [exerciseId, allExercises, allVideos, userPrograms, handleSetTitle]);

    return (
        <div>
            <div >
                <div>
                    <ReactPlayer url={link} controls={true} style={{maxHeight: '300px', maxWidth: '100%'}} />
                </div>
                <div>
                    {description}
                </div>
            </div>
        </div>




    )
}
